// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e6c02b9f","874":"a72a861a"}[chunkId] + ".chunk.js";
};